import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-cloudy')
export class ObiCloudy extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.9059 7.33337C16.4602 7.33337 14.2275 8.78594 13.128 11.1175L12.7119 11.9999L11.8194 11.6057C11.5845 11.5019 11.3479 11.4581 11.0941 11.4581C10.2161 11.4581 9.45258 12.0078 9.14967 12.8566L8.86573 13.6522L8.03382 13.5052C7.94322 13.4892 7.86878 13.4872 7.67452 13.4872C6.67487 13.4872 5.74958 13.897 5.05723 14.6572C4.37536 15.407 4 16.3655 4 17.377V17.4315C4.02838 18.5559 4.43966 19.5277 5.14566 20.2246L5.15837 20.2372L5.17062 20.2502C5.82894 20.9482 6.72663 21.3334 7.67451 21.3334H25.149C27.0296 21.3334 28.6667 19.6989 28.6667 17.5766C28.6667 15.7972 27.5238 14.3219 26.0459 13.9175L25.4233 13.7471L25.3221 13.1095C24.7959 9.7913 22.0403 7.33337 18.9059 7.33337ZM11.721 9.50746C13.2394 6.95044 15.926 5.33337 18.9059 5.33337C22.9098 5.33337 26.2905 8.28966 27.1814 12.1955C29.2636 13.0506 30.6667 15.1906 30.6667 17.5766C30.6667 20.7101 28.2253 23.3334 25.149 23.3334H7.67451C6.18125 23.3334 4.76271 22.7255 3.72795 21.6354C2.62481 20.5396 2.0369 19.0591 2.00026 17.4666L2 17.4551V17.377C2 15.8607 2.56574 14.4241 3.57784 13.3113C4.62294 12.1636 6.04868 11.5112 7.58866 11.4879C8.30065 10.2598 9.60309 9.45811 11.0941 9.45811C11.3005 9.45811 11.5098 9.47338 11.721 9.50746Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.9059 7.33337C16.4602 7.33337 14.2275 8.78594 13.128 11.1175L12.7119 11.9999L11.8194 11.6057C11.5845 11.5019 11.3479 11.4581 11.0941 11.4581C10.2161 11.4581 9.45258 12.0078 9.14967 12.8566L8.86573 13.6522L8.03382 13.5052C7.94322 13.4892 7.86878 13.4872 7.67452 13.4872C6.67487 13.4872 5.74958 13.897 5.05723 14.6572C4.37536 15.407 4 16.3655 4 17.377V17.4315C4.02838 18.5559 4.43966 19.5277 5.14566 20.2246L5.15837 20.2372L5.17062 20.2502C5.82894 20.9482 6.72663 21.3334 7.67451 21.3334H25.149C27.0296 21.3334 28.6667 19.6989 28.6667 17.5766C28.6667 15.7972 27.5238 14.3219 26.0459 13.9175L25.4233 13.7471L25.3221 13.1095C24.7959 9.7913 22.0403 7.33337 18.9059 7.33337ZM11.721 9.50746C13.2394 6.95044 15.926 5.33337 18.9059 5.33337C22.9098 5.33337 26.2905 8.28966 27.1814 12.1955C29.2636 13.0506 30.6667 15.1906 30.6667 17.5766C30.6667 20.7101 28.2253 23.3334 25.149 23.3334H7.67451C6.18125 23.3334 4.76271 22.7255 3.72795 21.6354C2.62481 20.5396 2.0369 19.0591 2.00026 17.4666L2 17.4551V17.377C2 15.8607 2.56574 14.4241 3.57784 13.3113C4.62294 12.1636 6.04868 11.5112 7.58866 11.4879C8.30065 10.2598 9.60309 9.45811 11.0941 9.45811C11.3005 9.45811 11.5098 9.47338 11.721 9.50746Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-cloudy': ObiCloudy;
  }
}
